import React, { useState, useEffect } from "react";
import "../../App.css";
import PageTitle from "../../Module/pageTitle";
import { useDispatch, useSelector } from "react-redux";
import { getState, setParentCourse } from "../../Action/courseAction";
import AdminTable from "../../Component/adminTable";
import {
  containsNumber,
  containsStartsWithSpecialCharsOrStartsWithNumberOrWhiteSpace,
  image_size_150,
  image_size_5MB,
  length_Fifty,
  length_One,
  length_Two,
  validateIsFileImageType,
  validateNameWithoutSpace,
  validateValueWithoutSpace,
} from "../../Utils/validators";
import { showErrorSnackbar } from "../../Action/snackbarAction";
import {
  containsStartsWithSpecialCharsOrStartsWithNumberOrWhiteSpaceErrMsg,
  multipleSpace,
  validateIsFileImageTypeErrMsg,
  validateIsNumberOnlyErrMsg,
} from "../../Utils/errorMsg";
import ImagePickerAndViewer from "../../Component/imagePickerAndViewer";
import { List } from "react-virtualized";
import {
  UpdateExamNew,
  deleteExam,
  getExamWithState,
  uploadExamLogo,
} from "../../Action/adminPanelAction";
import SubmitButton from "../../Component/SubmitButton";
import LabelField from "../../Component/labelField";
import FormInputField from "../../Component/FormInputField";

function EditExam() {
  const dispatch = useDispatch();
  const [examId, setExamId] = useState("");
  const [exam, setExam] = useState("");
  const [examSeoName, setExamSeoName] = useState("");
  const [examOrder, setExamOrder] = useState("");
  const [examLogo, setExamLogo] = useState("");
  const [selectedImage, setSelectedImage] = useState("");

  const [examList, setExamList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const initialFlag = [
    { sectionType: 1, isDisplay: false, name: "Online Course" },
    { sectionType: 2, isDisplay: false, name: "Books" },
    { sectionType: 3, isDisplay: false, name: "Test Series" },
  ]
  const [examFlag, setExamFlag] = useState(initialFlag);
  const { isEditMode } = useSelector((state) => ({
    isEditMode: state.courseReducer?.isEditMode,
  }));

  useEffect(() => {
    fetchExamData();
  }, []);

  const fetchExamData = () => {
    dispatch(
      getExamWithState((res) => {
        setExamList(res);
      })
    );
  };
  const handleUpdate = async (e) => {
    e.preventDefault();
    let newArr = stateList.filter(
      (item) => item._id === "0" && item.isSelected
    );
    let selectedStateList = stateList
      .filter((item) => item.isSelected)
      .map((item) => item?._id);

    if (selectedStateList?.length === 0) {
      dispatch(showErrorSnackbar("Please add Exam"));
      return;
    }
    if (newArr.length > 0) selectedStateList = [];
    if (selectedImage) {
      dispatch(
        uploadExamLogo(selectedImage, (res) => {
          if (res) {
            const postData = {
              name: exam,
              stateIds: selectedStateList,
              file: res?.imageLogo,
              seoName: examSeoName,
              order: examOrder,
            };
            if (examFlag?.length > 0) {
              const newArray = examFlag.map(itm => {
                const { name, _id, ...rest } = itm;
                return rest;
              });
              postData["sectionOrders"] = newArray
            }
            dispatch(
              UpdateExamNew(examId, postData, (res) => {
                if (res) {
                  dispatch(setParentCourse("isEditMode", false));
                  resetData();
                  fetchExamData();
                }
              })
            );
          }
        })
      );
    } else {
      const postData = {
        name: exam,
        stateIds: selectedStateList,
        seoName: examSeoName,
        order: examOrder,
      };
      if (examFlag?.length > 0) {
        const newArray = examFlag
          .filter(itm => itm.isDisplay === true && itm.order && itm.order !== "")
          .map(itm => {
            const { name, _id, ...rest } = itm;
            return rest;
          });
        postData["sectionOrders"] = newArray;
      }
      dispatch(
        UpdateExamNew(examId, postData, (res) => {
          if (res) {
            dispatch(setParentCourse("isEditMode", false));
            resetData();
            fetchExamData();
          }
        })
      );
    }
  };

  const resetData = () => {
    setExam("");
    setExamSeoName("");
    setExamOrder("");
    setSelectedImage("");
    setExamLogo("");
    setStateList([]);
    setExamFlag(initialFlag);
  };
  const changeFlagCheckBox = (event, index, type) => {
    let newArray = JSON.parse(JSON.stringify(examFlag));
    if (type === "examFlag") {
      if (event.target.checked) {
        newArray[index]["isDisplay"] = true;
        setExamFlag(newArray);
      } else {
        newArray[index]["isDisplay"] = false;
        setExamFlag(newArray);
      }
    } else if (type === "order") {
      const value = event.target.value;
      if (value !== "" && !/^\d+$/.test(value)) {
        dispatch(showErrorSnackbar("Please enter numeric value"));
        return;
      }
      newArray[index]["order"] = value;
      setExamFlag(newArray);
    }
  };
  const changeCheckBox = (event, index) => {
    let newArray = JSON.parse(JSON.stringify(stateList));
    if (event.target.checked) newArray[index]["isSelected"] = true;
    else newArray[index]["isSelected"] = false;
    setStateList(newArray);
  };

  const onChangeExamNameOrder = (value) => {
    if (value !== "") {
      if (!containsNumber(value)) {
        dispatch(showErrorSnackbar("Only Numbers are allowed!"));
        return;
      } else if (!validateValueWithoutSpace(value)) {
        dispatch(showErrorSnackbar(validateIsNumberOnlyErrMsg));
        return;
      } else setExamOrder(value);
    }
    setExamOrder(value);
  };

  const handleEdit = (value) => {
    dispatch(setParentCourse("isEditMode", true));
    setExamId(value?._id);
    setExam(value?.name);
    setExamSeoName(value?.seoName);
    setExamOrder(value?.order);
    setExamLogo(value?.file);
    setStateList([]);
    const matchExamFlag = examFlag.map(flag => {
      const match = value?.sectionOrders?.find(item => item?.sectionType === flag?.sectionType);
      return {
        ...flag,
        ...match,
      };
    });
    setExamFlag(matchExamFlag);
    dispatch(
      getState((resState) => {
        const allIndia = {
          name: "ALL INDIA",
          _id: "0",
        };
        resState.unshift(allIndia);
        let newArray = JSON.parse(JSON.stringify(resState));
        if (value?.stateIds.length > 0) {
          value?.stateIds.forEach((item) => {
            newArray.forEach((itemState, index) => {
              if (itemState._id === item._id)
                newArray[index]["isSelected"] = true;
            });
          });
        } else newArray[0]["isSelected"] = true;
        setStateList(newArray);
      })
    );
  };

  const handleDelete = (value) => {
    dispatch(
      deleteExam(value?._id, () => {
        fetchExamData();
      })
    );
  };

  const onChangeExam = (value) => {
    if (value.length >= length_Fifty) {
      dispatch(
        showErrorSnackbar(
          `Max Length ${length_Fifty - 1} reached for this field`
        )
      );
    }
    if (!validateNameWithoutSpace(value)) {
      dispatch(showErrorSnackbar(multipleSpace));
      return;
    }
    if (containsStartsWithSpecialCharsOrStartsWithNumberOrWhiteSpace(value)) {
      dispatch(
        showErrorSnackbar(
          containsStartsWithSpecialCharsOrStartsWithNumberOrWhiteSpaceErrMsg
        )
      );
      return;
    }
    setExam(value);
  };
  const onChangeExamSeoName = (value) => {
    if (value.length >= length_Fifty) {
      dispatch(
        showErrorSnackbar(
          `Max Length ${length_Fifty - 1} reached for this field`
        )
      );
    }
    if (!validateNameWithoutSpace(value)) {
      dispatch(showErrorSnackbar(multipleSpace));
      return;
    }
    if (containsStartsWithSpecialCharsOrStartsWithNumberOrWhiteSpace(value)) {
      dispatch(
        showErrorSnackbar(
          containsStartsWithSpecialCharsOrStartsWithNumberOrWhiteSpaceErrMsg
        )
      );
      return;
    }
    setExamSeoName(value);
  };

  const onChangeLogo = (e) => {
    e.preventDefault();
    if (!validateIsFileImageType(e)) {
      dispatch(showErrorSnackbar(validateIsFileImageTypeErrMsg));
      return;
    }
    if (e.target.files[0].size > image_size_5MB) {
      dispatch(showErrorSnackbar("File size should be less than 5 MB!!!"));
    } else {
      const reader = new FileReader();
      const file = e.target.files[0];
      reader.onloadend = () => {
        setExamLogo(reader.result);
        setSelectedImage(file);
      };
      reader.readAsDataURL(file);
    }
  };

  const validations = () => {
    let newArray = stateList.filter((item) => item.isSelected);
    return (
      exam === "" ||
      exam.length < 2 ||
      examLogo === "" ||
      examSeoName === "" ||
      examSeoName?.length < 2 ||
      newArray.length === 0 ||
      examOrder === ""
    );
  };
  function renderFlagRow({ index, key, style }) {
    return (
      <div key={key} style={style}>
        <div key={examFlag[index]?.sectionType} className="px-1">
          <div className="w-100">
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex e-input align-items-center">
                <input
                  id={examFlag[index]?.sectionType}
                  className="check"
                  type="checkbox"
                  checked={examFlag[index]?.isDisplay}
                  onChange={(event) => {
                    changeFlagCheckBox(event, index, "examFlag");
                  }}
                />
                <span className="checkVal">{examFlag[index]?.name}</span>
              </div>
              <input
                type="text"
                className="form-control"
                style={{ width: "100px" }}
                value={
                  examFlag[index]?.order
                    ? examFlag[index]?.order
                    : ""
                }
                onChange={(event) => {
                  changeFlagCheckBox(event, index, "order");
                }}
                disabled={!examFlag[index]?.isDisplay}
                maxLength={length_Two}
                minLength={length_One}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  function renderRow({ index, key, style }) {
    return (
      <div key={key} style={style}>
        <div key={stateList[index]?._id} className="p-1">
          <div className="w-100">
            <div className="d-flex justify-content-between">
              <div className="d-flex e-input align-items-center">
                <input
                  id={stateList[index]?._id}
                  className="check"
                  type="checkbox"
                  checked={stateList[index]?.isSelected}
                  onChange={(event) => {
                    changeCheckBox(event, index, "state");
                  }}
                />
                <span className="checkVal">{stateList[index]?.name}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const renderEditMode = () => {
    return (
      <div className="col-6">
        <div className="d-flex align-items-center">
          <LabelField labelName={"Exam Name"} isRequired={true} />
          <FormInputField
            key={"ex1"}
            placeholder={"Enter Exam Name"}
            setInputText={(value) => onChangeExam(value)}
            value={exam}
            maxLength={length_Fifty}
            minLength={length_Two}
          />
        </div>
        <div className="d-flex align-items-center">
          <LabelField labelName={"Exam SEO Name"} isRequired={true} />
          <FormInputField
            key={"ex2"}
            placeholder={"Enter Exam SEO Name"}
            setInputText={(value) => onChangeExamSeoName(value)}
            value={examSeoName}
            maxLength={length_Fifty}
            minLength={length_Two}
          />
        </div>
        <div className="d-flex align-items-center">
          <LabelField labelName={"Exam Name Order"} isRequired={true} />
          <FormInputField
            key={"ex2"}
            placeholder={"Enter Exam Name Order"}
            setInputText={(value) => onChangeExamNameOrder(value)}
            value={examOrder}
            maxLength={length_Fifty}
            minLength={length_One}
          />
        </div>
        <ImagePickerAndViewer
          labelName={"Exam Logo"}
          value={examLogo}
          handleChange={(e) => onChangeLogo(e)}
          htmlFor={"photo-upload"}
        />
        <div className="d-flex mb-4">
          <LabelField labelName={"Display Flag List"} />
          <div className="assign_container border rounded p-2">
            <div className="d-flex justify-content-between fw-bold mb-3">
              <span className="text-center px-2">Display Flag</span>
              <span className="text-center px-2">Order No</span>
            </div>
            <List
              height={150}
              rowCount={examFlag.length}
              rowHeight={50}
              rowRenderer={renderFlagRow}
              width={575}
            />
          </div>
        </div>
        <div className="d-flex">
          <LabelField labelName={"Exam State"} />
          <div className="assign_container border w-100 rounded p-2">
            <div className="input-border">
              <List
                height={350}
                rowCount={stateList.length}
                rowHeight={30}
                rowRenderer={renderRow}
                width={470}
              />
            </div>
          </div>
        </div>
        <SubmitButton name="Save and Update" validations={validations()} />
      </div>
    );
  };

  const renderListMode = () => {
    return (
      <AdminTable
        tableData={examList ? examList : []}
        pagename={"ExamName"}
        tableHead={[
          "S.N",
          "Exam Name",
          "Logo",
          // "CRM EXAM NAME",
          "SEO EXAM NAME",
          "Order",
          "Actions",
        ]}
        handleEdit={(value) => handleEdit(value)}
        handleDelete={(value) => handleDelete(value)}
        edit={true}
      />
    );
  };

  const handleCancelEditMode = () => {
    dispatch(setParentCourse("isEditMode", false));
  };

  return (
    <div className="contentBox">
      <PageTitle
        name={"EDIT EXAM NAME"}
        isEditMode={isEditMode}
        onClick={handleCancelEditMode}
      />
      <div className="formDiv contentScrollbar">
        <form className="col-auto formWidth" onSubmit={handleUpdate}>
          {!isEditMode ? renderListMode() : renderEditMode()}
        </form>
      </div>
    </div>
  );
}

export default EditExam;
